<ng-container>
<aw-wizard #wizard>
	<aw-wizard-step [stepTitle]="'Select Object'">
		<div class="panel-body">
    		<div class="row">
    			<div class="col-sm-5">
					<div class="panel panel-drk-orange">
						<div class="panel-body">
							<div class="col-sm-5"><label for=description >OBJECT</label></div>
							<div class="col-sm-7">
								<select class="form-control" [(ngModel)]="mEventReference" [ngModelOptions]="{standalone: true}" (change)="onSelectReference()">
									<option [ngValue]="null" selected="selected">-- Choose -- </option>
									<option *ngFor="let ref of mEventReferences" [ngValue]="ref">
										{{ref.name}}
									</option>
								</select>
							</div>
						</div>
					</div>
				</div>

				<div class="col-sm-7">
					<div class="panel panel-drk-orange">
						<div class="form-group" *ngIf="mEvent != null">
							<div class="row">
								<div class="col-sm-3"><label for=description>TYPE</label></div>
								<div class="col-sm-8">
									<select class="form-control" [(ngModel)]="mReferenceType" [ngModelOptions]="{standalone: true}" (change)="onSelectReferenceType()">
										<option [ngValue]="null" selected="selected">-- Choose -- </option>
										<option *ngFor="let kv of mReferenceTypes" [ngValue]="kv.value">
											{{kv.key}}
										</option>
									</select>
								</div>
							</div>
						</div>	
					
						<div class="form-group" *ngIf="mEvent != null">
							<div class="row">
								<div class="col-sm-3"><label for=description>OBJECT: </label></div>
								<div class="col-sm-8">
									<select class="form-control" [(ngModel)]="mInstance" [ngModelOptions]="{standalone: true}" (change)="onSelectInstance()">
										<option [ngValue]="null" selected="selected">-- Choose -- </option>
										<option *ngFor="let instance of mInstances" [ngValue]="instance">
											{{instance.name}}
										</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
    		</div>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary" awNextStep>NEXT <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
		</div>
	</aw-wizard-step>
	<aw-wizard-step [stepTitle]="'Select Function'">
		<div class="panel panel-drk-orange">
		    <div class="panel-body">
				<div class="form-group" *ngIf="mEvent != null">
					<div class="row">
						<div class="col-sm-2"><label for=description>FUNCTION: </label></div>
						<div class="col-sm-5">
							<select class="form-control" [(ngModel)]="mReferenceFunction" [ngModelOptions]="{standalone: true}" (change)="onSelectReferenceFn()">
								<option [ngValue]="null" selected="selected">-- Choose -- </option>
								<option *ngFor="let fn of mFunctions" [ngValue]="fn">
									{{fn.name}}
								</option>
							</select>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" awPreviousStep><i class="fa fa-arrow-left" aria-hidden="true"></i> BACK</button>
				<button type="button" class="btn btn-primary" awNextStep>NEXT <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
			</div>
		</div>
	</aw-wizard-step>
	<aw-wizard-step [stepTitle]="'Set Parameters'">
		<div class="panel panel-drk-orange" *ngIf="mReferenceFunction != null">
			<ng-container *ngFor="let param of mReferenceFunction.parameters; let i = index">
				<app-function-parameter-editor [action]="this.mAction" [parameter]="param" [index]="i"></app-function-parameter-editor>
			</ng-container>
		</div>

		<div class="modal-footer">
			<button type="button" class="btn btn-primary" awPreviousStep><i class="fa fa-arrow-left" aria-hidden="true"></i> BACK</button>
			<button type="button" class="btn btn-primary" awResetWizard>RESET <i class="fa fa-ban" aria-hidden="true"></i></button>
		</div>

	</aw-wizard-step>
</aw-wizard>	
</ng-container>
